import { useEffect, useMemo, useState } from 'react';
import { AdminController } from '../../../../controllers';
import constant from '../../../../utils/constant';
import {
	BeautifyThemeImg,
	DefaultThemeImg,
	LuxeFlexThemeImg,
} from '../../../../assets/img/ImgList';
import { MimaToastUtil } from '../../../../components';
import { useNavigate } from 'react-router-dom';

export const useAdminThemeSelector = () => {
	const navigate = useNavigate();
	const { data, isLoading } = AdminController.useGetBusinessDetails();

	const business = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data;
		}
		return {};
	}, [data?.data, data?.status]);

	const { settings } = business || {};
	const { tawk, website } = settings || {};

	const [loading, setLoading] = useState(false);

	const themes = useMemo(() => {
		return [
			{
				name: 'Default',
				key: 'DEFAULT',
				image: DefaultThemeImg,
			},
			{
				name: 'Beautify',
				key: 'UPGRADE',
				image: BeautifyThemeImg,
			},
			{
				name: 'Luxe Flex',
				key: 'LUXEFLEX',
				image: LuxeFlexThemeImg,
			},
		];
	}, []);

	const [activeTheme, setActiveTheme] = useState(themes[0]);

	const changeTheme = theme => {
		setActiveTheme(theme);
	};

	const currentTheme = useMemo(() => {
		const preloadTheme = settings?.website?.theme;
		if (preloadTheme) {
			return themes.filter(x => x.key === preloadTheme)[0];
		}

		return themes[0];
	}, [settings, themes]);

	useEffect(() => {
		if (currentTheme?.key) {
			setActiveTheme(currentTheme);
		}
	}, [currentTheme]);

	const customWebHandler = () => {
		navigate('/');
	};

	const setThemeHandler = async theme => {
		setLoading(true);
		const payload = {
			tawk,
			website: {
				...website,
				theme: theme,
			},
		};

		payload.website.faqs.forEach(faq => {
			delete faq._id;
		});

		const { status, errorMessage } =
			await AdminController.updateSettings(payload);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
			setLoading(false);
		}
	};

	return {
		themes,
		activeTheme,
		changeTheme,
		customWebHandler,
		currentTheme,
		setThemeHandler,
		loading,
		isLoading,
	};
};

export default useAdminThemeSelector;
